import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.fadeTimer = window.setTimeout(() => {
      this.element.classList.add("opacity-0")
      this.removeTimer = window.setTimeout(() => this.element.remove(), 500)
    }, 3000)
  }

  disconnect() {
    if (this.fadeTimer) window.clearTimeout(this.fadeTimer)
    if (this.removeTimer) window.clearTimeout(this.removeTimer)
  }
}
